import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import { assertSegmentIstLückenlosGefüllt, assertWarnungen, resetArrangement } from "./utils";
import { insertTor } from "../components/grundriss/TorDragging";
import { changeStreckenLaenge } from "../arrangement/grundrissFunctions";
import { getKanteInfo } from "../components/grundriss/Zaunlinie";
import * as Maths from "oc-commons/Maths";

export default {
  name: "TestVerteilungsstrategie",
};

export const testVerteilungstrategieUmschaltungMassBug: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;

  for (const länge of [0.71, 1.8, 3, 7]) {
    ["Strecke", "Rechteck"].forEach(async (form: any) => {
      agt.grundriss.setStandardForm(form, [länge, länge]);
      let index = -1;
      for (const strategieKey of [
        "StandardLinks",
        "LeerraumLinks",
        "StandardRechts",
        "LeerraumRechts",
        "StandardLinks",
        "Individuell",
        "StandardLinks",
        "Gleichmässig",
      ]) {
        index++;
        await subTestContext(`${form} ${länge}m ${strategieKey} index=${index} :`, () => {
          agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
          agt.update3d();
          if (strategieKey.includes("Leerraum")) {
            agt.segmente.forEach((s) => {
              const leerraumSumme = _.sum(s.getEmpties().map((e) => e.breite));
              assert.isTrue(leerraumSumme > 0.01, "es muss einen Leerraum geben");
            });
          } else {
            agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
          }
        });
      }
    });
  }
};

export const testVerteilungstrategieStandardHolz: Test = async () => {
  for (const strategieKey of ["LeerraumLinks", "LeerraumRechts"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.inspiration = APP.richMetadata.findInspiration("Inspiration XL Holzzaun");
      agt.füllungAuswahlwert = APP.richMetadata.findAuswahlwert("XL kdi");
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.grundriss.setStandardForm("Strecke", [10]);
      agt.update3d();
      const s = agt.segmente[0];
      assert.isTrue(s.getElemente().length > 1);
      const leerraumSumme = _.sum(s.getEmpties().map((e) => e.breite));
      assert.isTrue(leerraumSumme > 0.01, "es muss einen Leerraum geben");
    });
  }
};

export const testVerteilungstrategieStandardHolzTor: Test = async () => {
  for (const strategieKey of ["LeerraumLinks", "LeerraumRechts"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.inspiration = APP.richMetadata.findInspiration("Inspiration XL Holzzaun");
      agt.füllungAuswahlwert = APP.richMetadata.findAuswahlwert("XL kdi");
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.grundriss.setStandardForm("Strecke", [10]);
      agt.update3d();
      const s = agt.segmente[0];
      const tor = agt.createElementFromJson({
        form: "Einzeltor",
        füllungAuswahlwert: "XL kdi",
      });
      insertTor(s, 0.5, s.breite / 2, tor);
      agt.update3d();
      assert.deepEqualsPicked(
        { breite: 0.98, füllungAuswahlwert: "XL kdi", form: "Einzeltor" },
        tor.toJSON()
      );
      assert.isTrue(s.getElemente().length > 1);
      const leerraumSumme = _.sum(s.getEmpties().map((e) => e.breite));
      assert.isTrue(leerraumSumme > 0.01, "es muss einen Leerraum geben");
    });
  }
};

export const testVerteilungstrategieStandardTor: Test = async () => {
  for (const strategieKey of ["StandardLinks", "StandardRechts", "Gleichmässig"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.grundriss.setStandardForm("Strecke", [10]);
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.update3d();
      const s = agt.segmente[0];
      const tor = agt.createElementFromJson({
        form: "Einzeltor",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
        nimmStandardSize: true,
      });
      console.log("*** VOR INSERT TOR");
      insertTor(s, 0.5, s.breite / 2, tor);
      console.log("*** NACH INSERT TOR");
      APP.debugit = true;
      console.log("*** update 1");
      agt.update3d();
      console.log("*** update 2");
      agt.update3d();
      assert.deepEqualsPicked(
        { breite: 0.98, füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand", form: "Einzeltor" },
        tor.toJSON()
      );
      assertSegmentIstLückenlosGefüllt(s, false);
    });
  }
};

export const testVerteilungstrategieZweiStandardTore: Test = async () => {
  for (const strategieKey of ["StandardLinks", "StandardRechts", "Gleichmässig"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.grundriss.setStandardForm("Strecke", [10]);
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.update3d();
      const s = agt.segmente[0];
      const createTor = (x) => {
        const tor = agt.createElementFromJson({
          form: "Einzeltor",
          füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
          nimmStandardSize: true,
        });
        insertTor(s, 0.5, x, tor);
        agt.update3d();
        agt.update3d();
        assert.deepEqualsPicked(
          { breite: 0.98, füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand", form: "Einzeltor" },
          tor.toJSON()
        );
      };
      createTor(s.breite * 0.25);
      createTor(s.breite * 0.75);
      assert.equals(2, s.getTore().length);
      assertSegmentIstLückenlosGefüllt(s, false);
    });
  }
};

export const testVerteilungstrategieStandardTorRandLinks: Test = async () => {
  for (const strategieKey of ["StandardLinks", "StandardRechts", "Gleichmässig"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.grundriss.setStandardForm("Strecke", [2.8]);
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.update3d();
      const s = agt.segmente[0];
      const tor = agt.createElementFromJson({
        form: "Einzeltor",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
        nimmStandardSize: true,
      });
      insertTor(s, 0, 0, tor);
      agt.update3d();
      agt.update3d();
      assert.deepEqualsPicked(
        { breite: 0.98, füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand", form: "Einzeltor" },
        tor.toJSON()
      );
      assertSegmentIstLückenlosGefüllt(s, false);
    });
  }
};

export const testVerteilungstrategieStandardTorRandRechts: Test = async () => {
  for (const strategieKey of ["StandardLinks", "StandardRechts", "Gleichmässig"]) {
    await subTestContext(`${strategieKey} :`, () => {
      resetArrangement();
      const agt = APP.arrangement;
      agt.grundriss.setStandardForm("Strecke", [2.8]);
      agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert(strategieKey);
      agt.update3d();
      const s = agt.segmente[0];
      const tor = agt.createElementFromJson({
        form: "Einzeltor",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
        nimmStandardSize: true,
      });
      insertTor(s, 1, s.breite, tor);
      agt.update3d();
      agt.update3d();
      assert.deepEqualsPicked(
        { breite: 0.98, füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand", form: "Einzeltor" },
        tor.toJSON()
      );
      assertSegmentIstLückenlosGefüllt(s, false);
    });
  }
};

export const testVerteilungstrategieLeerraumLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.inspiration = APP.richMetadata.findInspiration(
    "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau"
  );
  agt.füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.update3d();
  const s = agt.segmente[0];
  s.remove(s.getElemente()[0]);
  agt.update3d();
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  agt.update3d();
  const condition = s.getElemente().every((e) => {
    const pfostenDistance = 0.03;
    const { pfostenLinks, pfostenRechts } = e;
    return (
      s.getX(pfostenLinks, 1) - s.getX(e, 0) < pfostenDistance &&
      s.getX(e, 1) - s.getX(pfostenRechts, 0) < pfostenDistance
    );
  });
  assert.isTrue(condition);
};

export const testVerteilungstrategieLeerraumRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.inspiration = APP.richMetadata.findInspiration(
    "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau"
  );
  agt.füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.update3d();
  const s = agt.segmente[0];
  s.remove(s.getElemente()[0]);
  agt.update3d();
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  agt.update3d();
  const condition = s.getElemente().every((e) => {
    const pfostenDistance = 0.03;
    const { pfostenLinks, pfostenRechts } = e;
    return (
      s.getX(pfostenLinks, 1) - s.getX(e, 0) < pfostenDistance &&
      s.getX(e, 1) - s.getX(pfostenRechts, 0) < pfostenDistance
    );
  });
  assert.isTrue(condition);
};

export const testVerteilungstrategieUmschaltungMitZweiTorenBeiTeilweiseGefüllterStrecke: Test =
  async () => {
    resetArrangement();
    const agt = APP.arrangement;
    agt.fromJSON({
      inspiration: "Inspiration DESIGN WPC Anthrazit",
      zaunart: "Sichtschutz",
      serie: "DESIGN WPC",
    });
    agt.grundriss.setStandardForm("Strecke", [9]);
    agt.update3d();
    const json = {
      breite: 9,
      verteilungsstrategieAuswahlwert: "Individuell",
      partsAndPfosten: [
        {
          type: "Element",
          breite: 0.9,
          höhe: 1.8,
          snap: 1,
          x0: 1.895,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          rahmenAuswahlwert: "Tor_Rahmen_DWPC_Silber",
          form: "Rechteck",
          massAuswahlwert: "90x180_Easy",
          detailSerie: "DESIGN WPC",
          anMauer: "AnMauer_nein",
          isMasselement: false,
        },
        {
          type: "Element",
          breite: 0.98,
          höhe: 1.8,
          snap: 1,
          x0: 2.8975,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          rahmenAuswahlwert: "Tor_Rahmen_DWPC_Silber",
          öffnungAuswahlwert: "Öffnung_nach_innen",
          anschlagAuswahlwert: "Anschlag_links",
          form: "Einzeltor",
          massAuswahlwert: "Einzeltor_Easy",
          detailSerie: "DESIGN WPC",
        },
        {
          type: "Element",
          breite: 0.9,
          höhe: 1.8,
          snap: 1,
          x0: 3.98,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          form: "Rechteck",
          massAuswahlwert: "90x180_Easy",
          detailSerie: "DESIGN WPC",
        },
        {
          type: "Element",
          breite: 1.8,
          höhe: 1.8,
          snap: 1,
          x0: 4.97,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          füllungAuswahlwertIndividualisiert: false,
          rahmenAuswahlwert: "Tor_Rahmen_DWPC_Silber",
          form: "Rechteck",
          massAuswahlwert: "180x180_Easy",
          detailSerie: "DESIGN WPC",
        },
        {
          type: "Element",
          breite: 1.08,
          höhe: 1.8,
          snap: 1,
          x0: 6.8725,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          rahmenAuswahlwert: "Tor_Rahmen_DWPC_Silber",
          öffnungAuswahlwert: "Öffnung_nach_innen",
          anschlagAuswahlwert: "Anschlag_links",
          form: "Einzeltor",
          massAuswahlwert: "Einzeltor_Easy",
          detailSerie: "DESIGN WPC",
          anMauer: "AnMauer_nein",
          einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
          beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
        },
        {
          type: "Element",
          breite: 0.9,
          höhe: 1.8,
          snap: 1,
          x0: 8.055,
          füllungAuswahlwert: "DWPC Anthrazit/Silber_easy",
          form: "Anschluss",
          massAuswahlwert: "Anschluss_Easy",
          anschlussAufRechts: false,
          detailSerie: "DESIGN WPC",
        },
      ],
    };
    agt.segmente[0].fromJSON(json);
    agt.update3d();
    const s = agt.segmente[0];
    assert.deepEqualsPicked(
      json.partsAndPfosten,
      s.getElemente().map((e) => e.toJSON())
    );
    s.verteilungsstrategieAuswahlwert = APP.richMetadata.findAuswahlwert("StandardLinks");
    agt.update3d();
    assert.equals(2, s.getTore().length, "Tore bleiben erhalten");
    assert.equals(7, s.getElemente().length, "Passende Elemente bleiben erhalten");
    // FIXME Elemente müssen entsprechend ihrer POSITION wiederverwendet werden!
  };

export const testVerteilungstrategieStandardLinksWpcClassicMandelSteckpfosten22m: Test =
  async () => {
    resetArrangement();
    const agt = APP.arrangement;
    agt.inspiration = APP.richMetadata.findInspiration("Inspiration SYSTEM WPC CLASSIC Mandel");
    agt.füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Mandel");
    agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("StandardLinks");
    agt.grundriss.setStandardForm("Strecke", [10]);
    agt.update3d();

    agt.changeSelectedPfosten({
      pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
    });

    // Streckenbreite ändern wie im Grundrisseditor per Number Input
    const kante = agt.grundriss.kanten[0];
    const { segmentEndenAusgleich } = getKanteInfo(kante);
    const distanceNeu = Math.max(0, Maths.round(22 + segmentEndenAusgleich, 4));
    changeStreckenLaenge(
      agt.grundriss.kanten,
      agt.grundriss.kantenIdToChangeCount,
      kante.id,
      distanceNeu
    );
    agt.update3d();

    const s = agt.segmente[0];
    assertSegmentIstLückenlosGefüllt(s);
    assertWarnungen(agt, []);
  };
